import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import { Switch, Table, Icon, Dropdown, Modal, notification } from "antd";
import DrawerPagina from "./DrawerPagina";
import Artigos from "../Artigos/Artigos";
import axios from "axios";

const confirm = Modal.confirm;
const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

class SubGroup extends Component {
    state = {
        paginas: [],
        paginasMobile: [],
        ativo: true,
        id: "",
        idSubgrupo: "",
        tituloArtigos: "",
        ordem: 1,
        //LOADING
        loading_table: false,
        //DRAWER
        visible: false,
        //SUBGRUPOS
        subgruposVisivel: false,
        //INFORMACOES
        paginaInformacoesVisivel: false
    };

    UNSAFE_componentWillMount() {
        this.listar();
    }

    handleChangeSwitch = ativo => {
        this.setState(
            {
                ativo
            },
            () => {
                this.listar();
            }
        );
    };

    //MONTA AS OPÇÕES DE MENU POR CADA CATEGORIA NA TABELA
    montarMenu = (id) => {
        const divStyle = { display: "flex", alignItems: "center", gap: "10px", justifyContent: "flex-end" };

        if (this.state.ativo)
            return (
                <div style={divStyle}>
                    <Link
                        to="#"
                        className="botao-icon-enviar"
                        title="Faq"
                        onClick={event => { event.stopPropagation(); this.carregarArtigos(id) }}
                    >
                        <Icon type="profile" />
                    </Link>
                    <Link
                        to="#"
                        className="botao-icon-inativar"
                        title="Inativar"
                        onClick={event => { event.stopPropagation(); this.ativar(id, this.state.ativo) }}
                    >
                        <Icon type="close" />
                    </Link>
                </div>
            );

        return (
            <div style={divStyle}>
                <Link
                    to="#"
                    className="botao-icon-ativar"
                    title="Ativar"
                    onClick={event => { event.stopPropagation(); this.ativar(id, this.state.ativo) }}
                >
                    <Icon type="check" />
                </Link>
                <Link
                    to="#"
                    className="botao-icon-excluir"
                    title="Excluir"
                    onClick={event => { event.stopPropagation(); this.excluir(id) }}
                >
                    <Icon type="delete" />
                </Link>
            </div>
        );
    };

    adicionar = () => {
        this.setState({
            id: "",
            visible: true
        })
    }

    editar = id => {
        this.setState({
            id,
            visible: true
        })
    }

    excluir = id => {
        confirm({
            title: "Pretende excluir este registo?",
            okText: "Confirmar",
            okType: "Cancelar",
            onOk: () => {
                axios({
                    method: "put",
                    url: "/api/empresa/excluir-faq-subgrupo",
                    params: {
                        id
                    }
                })
                    .then(() => {
                        openNotificationWithIcon("success", "Sucesso", "Registo excluido!");
                        this.listar();
                    })
                    .catch(error => {
                        openNotificationWithIcon("error", "Erro", error.response.data);
                    });
            }
        });
    };

    ativar = (id, ativo) => {
        confirm({
            title: ativo ? "Pretende inativar este registo?" : "Pretende ativar este registo?",
            okText: "Confirmar",
            okType: "Cancelar",
            onOk: () => {
                axios({
                    method: "put",
                    url: "/api/empresa/ativar-faq-grupo",
                    params: {
                        id
                    }
                })
                    .then(() => {
                        openNotificationWithIcon("success", "Sucesso", ativo ? "Registo inativado!" : "Registo ativado!");
                        this.listar();
                    })
                    .catch(error => {
                        openNotificationWithIcon(
                            "error",
                            "Erro",
                            ativo ? "Não foi possível inativar o registo!" : "Não foi possível ativar o registo!"
                        );
                    });
            }
        });
    };

    carregarArtigos = (id) => {
        var pagina = this.state.paginas.find(x => x.id === id)

        this.setState({
            id,
            tituloArtigos: `${this.props.titulo} - ${pagina.titulo}`,
            paginaInformacoesVisivel: true
        })
    }

    voltar = () => {
        this.setState({
            id: "",
            paginaInformacoesVisivel: false
        })
    }

    listar = () => {
        this.setState(
            {
                loading_table: true
            },
            () => {
                axios({
                    method: "get",
                    url: "/api/empresa/listar-faq-subgrupos",
                    params: {
                        id: this.props.id,
                        ativo: this.state.ativo
                    }
                })
                    .then(response => {
                        var paginas = [];
                        var paginasMobile = [];

                        response.data.map((pagina, index) => {
                            paginas.push({
                                key: index,
                                id: pagina.id,
                                titulo: pagina.titulo,
                                ordem: pagina.ordem,
                                opcoes: this.montarMenu(pagina.id)
                            });
                            paginasMobile.push({
                                key: index,
                                id: pagina.id,
                                titulo: <div className="bloco-pagina">
                                    <div className="info-pagina">
                                        <span className="titulo-pagina">{pagina.titulo}</span>
                                        <span className="ordem-pagina"><strong>Ordem:</strong> {pagina.ordem}</span>
                                    </div>
                                </div>,
                                ordem: pagina.ordem,
                                opcoes: this.montarMenu(pagina.id)
                            });
                        });

                        this.setState({
                            paginas,
                            paginasMobile,
                            ordem: (response.data.length + 1),
                            loading_table: false
                        });
                    })
                    .catch(error => {
                        if (error.response.status === 401)
                            this.setState({
                                redirect: true,
                                redirectLink: "/login"
                            });
                    });
            }
        );
    };

    atualizarRegisto = () => {
        this.setState({
            visible: false
        })
        this.listar();
    }

    onRowClick = (id) => {
        this.editar(id)
    }

    render() {
        const {
            paginas,
            paginasMobile,
            id,
            tituloArtigos,
            ordem,
            //LOADING
            loading_table,
            //DRAWER
            visible,
            //SUBGRUPOS
            paginaInformacoesVisivel,
        } = this.state;

        const columns = [
            {
                title: "Subgrupo",
                dataIndex: "titulo"
            },
            {
                title: "Ordem",
                dataIndex: "ordem"
            },
            {
                title: "",
                dataIndex: "opcoes",
                width: 10
            }
        ];

        const columnsMobile = [
            {
                title: "Subgrupo",
                dataIndex: "titulo"
            },
            {
                title: "",
                dataIndex: "opcoes",
                width: 10
            }
        ];

        if (paginaInformacoesVisivel)
            return (
                <Artigos
                    id={id}
                    titulo={tituloArtigos}
                    voltar={this.voltar}
                />
            )

        return (
            <div className="bloco-minha-conta">
                <div className="bloco-gestor-paginas">
                    <h3 className="titulo-separador" style={{ marginBottom: 20 }}>{this.props.titulo}</h3>
                    <div className="controlos controlos-pagina-informacoes">
                        <button
                            className="botao-principal botao-principal-redondo"
                            title="Adicionar"
                            onClick={this.adicionar}
                            disabled={!this.state.ativo}
                        >
                            +
                        </button>
                        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                            <Switch
                                checkedChildren="Ativos"
                                unCheckedChildren="Inativos"
                                defaultChecked
                                onChange={this.handleChangeSwitch}
                            />
                            <button className="botao-secundario botao-secundario-redondo" title="Voltar" style={{ marginLeft: 10 }} onClick={this.props.voltar}>
                                <Icon type="arrow-left" />
                            </button>
                        </div>
                    </div>
                    <div className="bloco-tabela">
                        <Table
                            id="tabela_categorias"
                            className="tabela-paginas-desktop"
                            loading={{
                                spinning: loading_table,
                                indicator: (
                                    <div className="loading-data-table">
                                        <div className="loading" />
                                    </div>
                                )
                            }}
                            columns={columns}
                            dataSource={paginas}
                            pagination={false}
                            rowClassName="clickeble-row"
                            onRow={(record, index) => {
                                return {
                                    onClick: () => this.onRowClick(record.id)
                                };
                            }}
                            locale={{ emptyText: "Não existem dados!" }}
                        />
                        <Table
                            id="tabela_categorias"
                            className="tabela-paginas-mobile"
                            loading={{
                                spinning: loading_table,
                                indicator: (
                                    <div className="loading-data-table">
                                        <div className="loading" />
                                    </div>
                                )
                            }}
                            columns={columnsMobile}
                            dataSource={paginasMobile}
                            pagination={false}
                            rowClassName="clickeble-row"
                            onRow={(record, index) => {
                                return {
                                    onClick: () => this.onRowClick(record.id)
                                };
                            }}
                            locale={{ emptyText: "Não existem dados!" }}
                        />
                    </div>
                </div>
                <DrawerPagina
                    ativo={this.state.ativo}
                    id={id}
                    grupoId={this.props.id}
                    ordem={ordem}
                    visible={visible}
                    onClose={() => this.setState({ visible: false })}
                    atualizarRegisto={this.atualizarRegisto}
                />
            </div>
        );
    }
}

export default SubGroup;
